import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { SearchPage } from '~/features/search/search-page';

/**
 * `?q=` carries what was typed, from the palette or a record's own search.
 * Digits typed straight into the address (a phone number) arrive parsed as a
 * number, and are the words as typed, not a number to format.
 */
const search = z.object({
  q: z.preprocess((raw) => (typeof raw === 'number' ? `${raw}` : raw), z.string().optional()).catch(undefined),
});

function SearchRoute(): ReactElement {
  const { q } = Route.useSearch();
  return <SearchPage q={q ?? ''} />;
}

export const Route = createFileRoute('/_app/search')({
  validateSearch: search,
  component: SearchRoute,
});
